module.exports = __webpack_public_path__ + "img/slider-3.90f4e91.png";